import clsx from "clsx";

import {
  ButtonBase,
  type ButtonBaseProps,
} from "@/components/ButtonBase/ButtonBase";
import { Skeleton } from "@/components/Skeleton/Skeleton";

export type Props = Pick<
  ButtonBaseProps,
  "onClick" | "children" | "role" | "aria-checked"
> & {
  fullWidth?: boolean;
  borderRadius?: string;
  active?: boolean;
};

export function FilterButton({
  onClick,
  children,
  fullWidth,
  active,
  borderRadius = "var(--radius-xl)",
  role,
  "aria-checked": ariaChecked,
}: Props) {
  const borderRadiusClass =
    borderRadius === "var(--radius-2xl)" ? "rounded-2xl" : "rounded-xl";

  return (
    <ButtonBase
      onClick={onClick}
      role={role}
      aria-checked={ariaChecked}
      className={clsx(
        "relative inline-flex shrink-0 items-center gap-1 overflow-hidden px-3 py-2 text-start text-sm font-medium text-text-primary shadow-xs",
        borderRadiusClass,
        fullWidth ? "w-full justify-center" : "w-auto",
        active
          ? "border border-surface-accent-strong bg-surface-accent-softer"
          : "border-0 bg-white",
      )}
    >
      {children}
    </ButtonBase>
  );
}

export const FilterButtonSkeleton = () => (
  <div className="flex items-center justify-center rounded-xl bg-white px-3 py-2">
    <Skeleton width={86} height={20} />
  </div>
);
